import request from '@/utils/request'

export function updateExchangeCodeCfg(data) {
  return request({
    url: 'api/v1/exchange-code/update',
    method: 'post',
    data: data
  })
}

export function getExchangeCodeList(data) {
  return request({
    url: 'api/v1/exchange-code/getList',
    method: 'post',
    data: data
  })
}

export function getExchangeCodeUrlList() {
  return request({
    url: 'api/v1/exchange-code/getCodeUrl',
    method: 'get'
  })
}

